import { useState, useEffect } from "react";

export default function useLocalStorage(key, defaultValue) {
  const [value, setValue] = useState(() => {
    // getting stored value
    const saved = localStorage.getItem(key);
    const item = JSON.parse(saved);
    return item || defaultValue;
  });

  useEffect(() => {
    // storing value when the setValue is triggered
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);
  return [value, setValue];
}
